<template>
  <div class="media-viewer-conatiner" v-if="visible" @click="close" v-touch:touchhold="showActionSheet">
    <template v-if="media.type === 'audio' && media.url">
      <audio
        controls autoplay preload="auto" playsinline="true"
        class="media-show animate__animated animate__zoomIn animate__fadeIn animate__faster"
        @click.stop
      >
        <source :src="media.url" type="audio/mp3" error="onError" />
      </audio>
    </template>
    <template v-if="media.type === 'video' && media.url">
      <video
        controls autoplay preload="auto" playsinline="true"
        class="media-show animate__animated animate__zoomIn animate__fadeIn animate__faster"
        @click.stop
      >
        <source :src="media.url" type="video/mp4" error="onError" />
      </video>
    </template>

    <div class="btn-close"></div>
  </div>
</template>

<script>
import { isWXWork, isWeixin, isQQ } from '@/utils/isWX';

export default {
  name: 'MediaViewer',
  data() {
    return {
      visible: false,
      media: {
        url: '', // url
        type: '', // audio OR video
        downloadFun: null, // 下载回调函数
        ext: '',  // 文件后缀名，预留
      },
    };
  },

  computed: {
    isMobile() {
      return !this.$platform.pc;
    },
  },

  methods: {
    close() {
      this.visible = false;
      setTimeout(() => {
        this.$destroy();
      }, 500);
    },
    /**
     * 出错处理
     */
    onError() {
      this.$Confirm({
        title: this.$t('common_play_error'),
        confirmText: this.$t('common_download'),
      })
        .then(() => {
          if (typeof(this.media.downloadFun) === 'function') {
            this.media.downloadFun();
          }
        })
        .catch(() => {});
    },
    /**
     * H5场景下，微信内置环境的浏览器媒体组件，没有下载功能，因此要给出一个复制url的功能。
     */
    showActionSheet() {
      // 仅H5 微信、企微环境QQ环境才需要处理。其他环境不处理。
      if (!this.$ActionSheet || !this.isMobile || (!isWXWork && !isWeixin && !isQQ)) {
        return;
      }

      const itemList = ['复制链接到浏览器下载'];
      this.$ActionSheet.show({
        itemList,
        success: (/* index */) => {
          this.$copyText(this.media.url)
            .then(() => {
              this.$Toast(this.$t('chat_add_friend_copy_success_msg'));
            }, () => {
              this.$Toast({ text: '复制失败，请重试', type: 'error' });
            });
        },
        fail() { },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import './bg.less';
.media-viewer-conatiner {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
  .btn-close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 36px;
    height: 36px;
    background: url(@bg) no-repeat center center;
    transition: opacity 0.3s;
    background-color: rgba(120, 132, 158, 0.4);
    background-size: 14px 14px;
    border-radius: 50%;
    cursor: pointer;
    opacity: 1;
    backdrop-filter: blur(27.1828px);

    &:hover {
      opacity: 0.8;
    }
  }
  .btn-close:hover {
    opacity: 0.8;
  }
  .media-show {
    max-width: 80%;
    max-height: 80%;
    animation-duration: 300ms;
  }
}

// h5页面效果
.h5-site {
  .media-viewer-conatiner {
    .media-show {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
